export default __webpack_public_path__ + "static/featured-hero-0fbb088026b3ce60eb6baf4952abbe92.png";